import type { EssentialInfoGroup } from '../types';

type Props = {
  groups: EssentialInfoGroup[];
  footnote?: string;
  heading?: {
    lead: string;
    accent: string;
  };
};

export default function EssentialInfo({ groups, footnote, heading }: Props) {
  const displayHeading = heading ?? {
    lead: 'Property details,',
    accent: 'at a glance.',
  };

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="mb-10 md:mb-12">
          <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl leading-[1.07] tracking-[-0.01em]">
            {displayHeading.lead}
            <span className="block italic font-light text-foreground-600"> {displayHeading.accent}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {groups.map((g) => (
            <div
              key={g.heading}
              className="bg-background-100/60 border border-background-200/80 rounded-lg p-7"
            >
              <p className="text-[11px] uppercase tracking-[0.22em] text-foreground-500 mb-5">
                {g.heading}
              </p>
              <ul className="space-y-3">
                {g.items.map((item, index) => (
                  <li key={`${item}-${index}`} className="flex items-start gap-2.5 text-sm text-foreground-700 leading-relaxed">
                    <span className="mt-[6px] w-1 h-1 rounded-full bg-accent-500 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {footnote && (
          <p className="mt-8 text-xs text-foreground-400 max-w-xl leading-relaxed">
            {footnote}
          </p>
        )}
      </div>
    </section>
  );
}
